module.exports = __webpack_public_path__ + "static/media/PQUAD.05688e66.jpeg";